import { compress } from "micro-graphql-react"

export default compress`
  mutation(
    $studentId: ID!
    $subjectId: ID!
  ) {
    addStudentSubject(
      studentId: $studentId
      subjectId: $subjectId
    ) {
      subject {
        id
        name
      }
    }
  }
`
